import { PolicyUnit } from "@covertree/new-business-graphql";
import { MineSubsidenceScheduledOption } from "./option";

const getMineSubsidenceScheduledOption = (
  unit: Omit<PolicyUnit, "pricing">
) => {
  const {
    address: { state },
  } = unit;

  if (state === "IL") {
    return MineSubsidenceScheduledOption.Illinois;
  }

  return MineSubsidenceScheduledOption.Default;
};

export { getMineSubsidenceScheduledOption };
